<script setup>
import { ref, onMounted } from 'vue'
import { fetchCompanyData } from '@/services/api'

import bgHero from '@/assets/img/bg-hero-about.png'
import illustration from '@/assets/img/smilepicture-logo.png'
import illustration2x from '@/assets/img/smilepicture-logo.png'
import OurServices from '../components/OurServices.vue'
import MeetOurTeam from '../components/MeetOurTeam.vue'
import HowWeWorks from '../components/HowWeWorks.vue'
import Client from '../components/Client.vue'
import DynamicHero from '../components/DynamicHero.vue'

const slides = ref([])
const services = ref([])
const clients = ref([])
const teams = ref([])
const isLoading = ref(true)

onMounted(async () => {
    try {
        const data = await fetchCompanyData()
        slides.value = data.slides || []
        services.value = data.services || []
        clients.value = data.clients || []
        teams.value = data.teams || []
    } catch (error) {
        console.error('Failed to load company data:', error)
    } finally {
        isLoading.value = false
    }
})
</script>

<template>
    <!-- DYNAMIC HERO SECTION -->
    <DynamicHero :slides="slides" :fallbackBg="bgHero" fallbackTitle="Turning Ideas into Visual Stories"
        fallbackDescription="SmilePictures is a creative video production house dedicated to crafting stories, capturing moments, and transforming ideas into visuals that truly connect."
        fallbackButtonText="Learn About Our Services" fallbackButtonLink="/services"
        breadcrumbLabel="Company Smile Picture" />

    <!-- CARD / ABOUT SECTION -->
    <section class="wrapper bg-black">
        <div class="container py-14">
            <div class="row gx-md-8 gx-xl-12 gy-10 align-items-center">
                <!-- LOGO -->
                <div class="col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-center">
                    <img class="img-fluid" :src="illustration" :srcset="`${illustration2x} 2x`" alt="Smile Picture Logo"
                        style="max-width: 250px" />
                </div>

                <!-- TEXT -->
                <div class="col-lg-6 text-center text-lg-start">
                    <h1 class="display-2 mb-4 text-secondary">
                        Hola
                    </h1>

                    <p class="lead text-white">
                        We are SmilePictures by RDPL, an Indonesian creative laboratory with a
                        deep passion for content creation and video production. We craft
                        stories, capture moments, and turn ideas into visuals that truly
                        connect.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <Client v-if="!isLoading && clients.length > 0" :clients="clients" />
    <Client v-else />

    <OurServices v-if="!isLoading && services.length > 0" :services="services" />
    <OurServices v-else />

    <MeetOurTeam v-if="!isLoading && teams.length > 0" :teams="teams" />
    <MeetOurTeam v-else />

    <HowWeWorks />
</template>
